import { render, staticRenderFns } from "./WeedsClassPallete.vue?vue&type=template&id=1d805971&scoped=true&"
import script from "./WeedsClassPallete.vue?vue&type=script&lang=ts&"
export * from "./WeedsClassPallete.vue?vue&type=script&lang=ts&"
import style0 from "./WeedsClassPallete.vue?vue&type=style&index=0&id=1d805971&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d805971",
  null
  
)

export default component.exports